module.exports = __webpack_public_path__ + "static/media/dot.7cf6f58f.svg";